import dayjs from 'dayjs'
import _ from 'lodash-es'
import type { ZodError } from 'zod'
import zodError from '@/utils/zodError.json'

export function silentCloned(obj: any) {
  try {
    return JSON.parse(JSON.stringify(obj))
  }
  catch (e) {
    console.error(e)
    return undefined
  }
}

export function silentParse(data: any) {
  try {
    return JSON.parse(data)
  }
  catch (error) {
    return null
  }
}

export function debounce(fn: () => void, delay: number) {
  let timer = null as any
  return function () {
    if (timer)
      clearTimeout(timer)

    timer = setTimeout(fn, delay)
  }
}

/**
 * 清除 vue 对象 绑定属性
 * @param source vue 响应式对象
 * @returns
 */
export function cleanSource(source: any) {
  if (!_.isObject(source))
    return source
  return JSON.parse(JSON.stringify(source))
}

export function getObjId(obj: any) {
  if (typeof obj == 'string')
    return obj
  if (obj?._id)
    return obj._id
  return obj
}

export function el2mongoQDate(date?: any) {
  if (!date || date.length === 0)
    return date

  const [start, end] = date
  return {
    $gte: dayjs(start).toDate().getTime(),
    $lt: dayjs(end).toDate().getTime(),
  }
}

export function guessFetchError(error: any) {
  const { status, message, data } = error
  switch (status) {
    case 403: return '权限不足'
    case 404: return '资源不存在'
    case 400: {
      return `参数错误${data?.message || message}`
    }
    case 500: {
      return guessMongoError(error)
    }
    default: return data.message || message
  }
}

export function guessMongoError(error: any) {
  const data = error.response?._data || {}
  const message = data.message

  const reg = /E11000 duplicate key/g
  if (reg.test(message)) {
    const info = message.match(/dup key: (.*)$/)?.[1]
    return `记录已存在: ${info}`
  }
  else { return message }
}

_.templateSettings.interpolate = /{{([\s\S]+?)}}/g

export function guessZodError(error: ZodError) {
  return error.issues.map((issue) => {
    const { code } = issue

    const target = zodError.errors[code]

    if (!target)
      return issue.message

    let parsed = ''
    if (typeof target === 'string') {
      parsed = _.template(target)(issue)
    }
    else if (code === 'too_small' || code === 'too_big') {
      const match = (target as any)[issue.type]
      const tempstr = issue.exact ? match.exact : issue.inclusive ? match.inclusive : match.not_inclusive
      parsed = _.template(tempstr)(issue)
    }
    return `${issue.path.join(',')} ${parsed}`
  }).join('\n')
}
